import React, {useContext} from 'react';
import LangContext from '../../context/LangContext';
import {Typography} from '@material-ui/core/';

export const Orangerietdescription = (props) => {
  const [lang] = useContext(LangContext);
    return <>
      {lang==="se" ? <>
        <Typography variant="h5" gutterBottom>
          Orangeriet
        </Typography>
        Byggnaden utformas som ett vanligt industriellt växthus, med en isolerad kärna - en konstruktion som är både billig och enkel att uppföra.<br/><br/>

        Orangeriets möjliga tänkta funktioner:<br/>
        - Informationscenter för Korsholms kommun<br/>
        - Forum att diskutera den löpande stadsutvecklingen<br/>
        - Center där mäklare kan informera om bostäder som är till salu<br/>
        - Publika funktioner som t.ex. café<br/>
        - Flexibel yta, för utställningar, event och folksamlingar<br/>
        - Turistinformation<br/>
        - Vänthall för kollektivtrafiken med information<br/>
        - Taxistation
        </> : <>
        <Typography variant="h5" gutterBottom>
        Talvipuutarha
        </Typography>
        Rakennus olisi muodoltaan teollisen kasvihuoneen näköinen, eristetyllä rungolla. Rakennelma joka on sekä helppo, että halpa rakentaa.<br/><br/>

        Talvipuutarhan mahdolliset käyttötarkoitukset:<br/>
        - Mustasaaren kunnan infopiste<br/>
        - Kohtaamispaikka keskustan kehitykselle<br/>
        - Tietoa alueen asunnoista<br/>
        - Kahvila<br/>
        - Joustava tila tapahtumille, näyttelyille ym.<br/>
        - Matkailun infopiste<br/>
        - Paikallisliikenteen odotustila<br/>
        - Taksiasema
      </>}
  </>
};

export default Orangerietdescription;